import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    { 
      id: 'OO',
      Nombre: i18n.t('tipos.invoice_class.original'),
    },
    { 
      id: 'OR',
      Nombre: i18n.t('tipos.invoice_class.original_rectificativa'),
    },
    { 
      id: 'OC',
      Nombre: i18n.t('tipos.invoice_class.original_recapitulativa'),
    }, 
    { 
      id: 'CO',
      Nombre: i18n.t('tipos.invoice_class.copia_original'),
    },
    { 
      id: 'CR',
      Nombre: i18n.t('tipos.invoice_class.copia_rectificativa'),
    },
    { 
      id: 'CC',
      Nombre: i18n.t('tipos.invoice_class.copia_recapitulativa'),
    },
  ]
}

export function TIPOS_INVOICE_CLASS (state) {
  return configHelper.getConfig(state, 'TIPOS_INVOICE_CLASS', GenerateConfig)
}
